import { BlockText, Separator, SideBox } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { SidebarInternationalOfferBenefits } from "./SidebarInternationalOfferBenefits";

interface ISidebarAdditionalPackageOfferProps {
  anniversaryDate: number | undefined;
  productOfferPrice: number;
  testId?: string;
}

export function SidebarInternationalOffer({
  anniversaryDate,
  productOfferPrice,
  testId,
}: ISidebarAdditionalPackageOfferProps) {
  return (
    <SideBox
      isExpandable={false}
      testId={testId}
      title="pakiet rozmów międzynarodowych"
    >
      <BlockText className="my-3" size="keySM" weight="bold">
        {productOfferPrice && formatPrice(productOfferPrice)}
        <span className="text-size-16 font-normal"> zł</span>
      </BlockText>
      <Separator size="s" thickness="medium" tone="accent" />
      <SidebarInternationalOfferBenefits anniversaryDate={anniversaryDate} />
    </SideBox>
  );
}
